import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function storeIsoLog(params) {
  const axios = axiosInstance().primoLab;
  let data = [];

  await axios
    .post(`/iso-logs`, params)
    .then(async (response) => {
      data = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { data };
}
